import { render } from "./ODFilterManager.vue?vue&type=template&id=05a5cc8d&scoped=true"
import script from "./ODFilterManager.vue?vue&type=script&lang=js"
export * from "./ODFilterManager.vue?vue&type=script&lang=js"

import "./ODFilterManager.vue?vue&type=style&index=0&id=05a5cc8d&scoped=true&lang=css"
import "./ODFilterManager.vue?vue&type=style&index=1&id=05a5cc8d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a5cc8d"]])

export default __exports__